<template>
  <nav class="sidebar open">
    <router-link
        v-for="(item, index) in navItems"
        :key="index"
        :to="item.href"
        class="btn-nav btn-nav-font"
        :class="{ 'opacity-50': !item.active }"
    >
      {{ item.label }}
    </router-link>
  </nav>
</template>

<script setup>
import { onMounted } from 'vue'

// Данные меню
const navItems = [
  { label: 'How STIMA Works?', href: '/how-stima-work', active: true },
  { label: 'Traceability Network', href: '#', active: false },
  { label: 'Artificial Intelligence', href: '#', active: false },
  { label: 'Blockchain', href: '#', active: false },
  { label: 'Exchange', href: '#', active: false },
  { label: 'Payment System', href: '#', active: false },
  { label: 'Advisory', href: '#', active: false },
]

const toggleSidebar = () => {
  const main = document.querySelector('#main')
  const sidebar = document.querySelector('.sidebar')
  const handle = document.querySelector('.sidebar-handle')

  if (main && sidebar && handle) {
    main.classList.toggle('open')
    sidebar.classList.toggle('open')
    handle.classList.toggle('open')
  }
}

// Обработчик клика
onMounted(() => {
  const handle = document.querySelector('.sidebar-handle')
  if (handle) {
    handle.addEventListener('click', toggleSidebar)
  }
})
</script>
